export default "__VITE_ASSET__D3gYV3Vk__"